import services from 'services/module';
import { HttpSvcFactory } from 'services/HttpSvc';

export class EmbedsSvc {
    constructor(private HttpSvc: HttpSvcFactory) {}

    getEmbedStats() {
        return this.HttpSvc<anm.UserStats>('profile/stats/embed').secureGet();
    }
}

services.service('embedSvc', EmbedsSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/EmbedsSvc.ts